import React from "react";
import { Link } from 'react-router-dom';
import Card from 'react-bootstrap/Card';

function RoleCard({imageUrl, title, onRoleSelect}) {
    const handleClick = () => {
        onRoleSelect(title);
    };
    return (
        <Card className="p-1 my-4 border-0" style={{ width: '12rem' }}>
             <Link to="/application" onClick={handleClick}>
                <Card.Img variant="top" src={`${process.env.PUBLIC_URL}/${imageUrl}`} />
             </Link>
            <Card.Body>
                <Card.Title className="text-decoration-none">
                    <Link to="/application" onClick={handleClick}>{title}</Link>
                </Card.Title>
            </Card.Body>
        </Card>
    );
}

export default RoleCard;